import { groupBy } from "simple-utils";

type Impossible<K extends keyof any> = {
    [P in K]: never;
  };
  
export type NoExtraProperties<T, U extends T = T> = U & Impossible<Exclude<keyof U, keyof T>>;

export function isIpad(){
  var isDefaultValue = document.querySelector('meta[name=viewport]')?.getAttribute("content").match(/device-width/)
  return !isDefaultValue;
}

export function asIdSet<T>(list:T[], getter:(i: T)=>number){
    const set = groupBy(list, i => getter(i) + "")
    return Object.keys(set).map(a => parseInt(a));
}